import React from 'react';
import { customRounder, formatReceiptDateTime } from '../util/Formater';

export default class ModalReceipt extends React.Component {
   render() {
      let { tokenReceipt } = this.props;
      return (
         <>
            <div className='receipt-container'>
               <div className='receipt-address'>
                  <img
                     src='https://i.ibb.co/nbnhXxD/e-Step-logo.png'
                     alt='logo'
                     width='80'
                     height='30'
                  />
                  <p className='is-size-7'>EUCL-eStep</p>
                  <p className='is-size-7'>Electricity Receipt #{tokenReceipt.receiptNumber}</p>
               </div>
               <div className='receipt-customer'>
                  <div>Customer Information</div>
                  <div>{tokenReceipt.firstName}</div>
                  <div>Meter number: {tokenReceipt.meterNumber}</div>
                  <br />
                  <div>VEND INFO</div>
                  <div>TIN 103372638 (EUCL)</div>
                  <div>{formatReceiptDateTime(tokenReceipt.receiptTime)}</div>
                  <div>TID: {tokenReceipt.transactionId}</div>
                  <div>Electricity Pre-paid - Service Credit</div>
               </div>
               <div className='token'>
                  <div>{tokenReceipt.token}</div>
               </div>
               <div className='receipt-box'>
                  <div className='receipt-item'>Total Units</div>
                  <div className='receipt-item'>{`${tokenReceipt.units} Kwh`}</div>
                  {tokenReceipt.receiptItems &&
                     tokenReceipt.receiptItems.map((item, index) => {
                        return (
                           <>
                              <div className='receipt-item'>{item.desc}</div>
                              <div className='receipt-item'>{`${customRounder(
                                 item.value
                              )} FRW`}</div>
                           </>
                        );
                     })}
                  <div className='receipt-item'>TOTAL TTC</div>
                  <div className='receipt-item'>{`${tokenReceipt.purchaseAmount} FRW`}</div>
               </div>
               <div>
                  <span>*************************************************************</span>
                  <div className='ad'>Kanda *720# ugure umuliro byoroshye ukoresheje eStep</div>
                  <span>*************************************************************</span>
               </div>
            </div>
         </>
      );
   }
}
